/**
 * Throttle function execution to run at most once per animation frame
 * @param fn - Function to throttle
 * @returns Throttled function
 */
export function throttleRaf<T extends (...args: any[]) => any>(fn: T): T {
  let scheduled = false;
  let args: Parameters<T>;

  return function (this: any, ...a: Parameters<T>): void {
    args = a;
    const boundFn = fn.bind(this);

    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        boundFn(...args);
      });
    }
  } as T;
}
